import { WaveCard }            from './WaveCard.jsx'
import { MoodCard }            from './MoodCard.jsx'
import { EnergyCard }          from './EnergyCard.jsx'
import { WinsCard }            from './WinsCard.jsx'
import { LearningsCard }       from './LearningsCard.jsx'
import { RisksCard }           from './RisksCard.jsx'
import { AsksCard }            from './AsksCard.jsx'
import { FocusCard }           from './FocusCard.jsx'
import { WLBCard }             from './WLBCard.jsx'
import { KudosCard }           from './KudosCard.jsx'
import { FeedbackCard }        from './FeedbackCard.jsx'
import { PrioritiesCard }      from './PrioritiesCard.jsx'
import { StuckCard }           from './StuckCard.jsx'
import { WeekRatingCard }      from './WeekRatingCard.jsx'
import { SSCCard }             from './SSCCard.jsx'
import { SupportCard }         from './SupportCard.jsx'
import { OneWordCard }         from './OneWordCard.jsx'
import { GratitudeCard }       from './GratitudeCard.jsx'
import { ProgressUpdatesCard } from './ProgressUpdatesCard.jsx'
import { WorkloadCard }        from './WorkloadCard.jsx'
import { ClarityCard }         from './ClarityCard.jsx'

/**
 * Map from PrepCard.kind → React component.
 * Keys match the Phase D kind enum.
 */
export const KIND_COMPONENTS = {
  'prep-wave':             WaveCard,
  'prep-mood':             MoodCard,
  'prep-energy':           EnergyCard,
  'prep-wins':             WinsCard,
  'prep-learnings':        LearningsCard,
  'prep-risks':            RisksCard,
  'prep-asks':             AsksCard,
  'prep-focus':            FocusCard,
  'prep-wlb':              WLBCard,
  'prep-kudos':            KudosCard,
  'prep-feedback':         FeedbackCard,
  'prep-priorities':       PrioritiesCard,
  'prep-stuck':            StuckCard,
  'prep-week-rating':      WeekRatingCard,
  'prep-ssc':              SSCCard,
  'prep-support':          SupportCard,
  'prep-one-word':         OneWordCard,
  'prep-gratitude':        GratitudeCard,
  'prep-progress-updates': ProgressUpdatesCard,
  'prep-workload':         WorkloadCard,
  'prep-clarity':          ClarityCard,
}

/** Returns the component for a given card kind, or null. */
export function resolveKindComponent(kind) {
  return KIND_COMPONENTS[kind] ?? null
}
